<div class="align-self-center" style="background-color: #ffe600; color: black; padding-right: 0.5rem; text-align:center">
  <i class="material-icons ev-nav-version-mark" style="vertical-align: top">lock</i>
  <span>Read-only version</span>
</div>
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Please acknowledge to proceed</h4>
</div>
<div class="modal-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-1 modal-exclamation">
        <span class="material-icons error-icon">error</span>
      </div>
      <div class="col-11">
        <div class="body">
          <p>
            You're entering a <b> read-only version</b>. To edit or reuse a completed study, click ‘Leverage’ to open it in Gen AI Version where editing and saving are enabled. 
          </p>
          <p>
            Click the back button to return to the audit approved Gen AI Version.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer justify-content-center">
  <button type="button" class="btn btn-default" (click)="close()">Back</button>
  <button type="button" class="btn btn-primary" (click)="acknowledge()" title="Please scroll to the bottom to acknowledge.">
    Acknowledge
  </button>
</div>
